import {Locale} from '../constants'
import {DEFAULT_HOST} from '../router'
import {routing} from './routing'

export const getOrigin = () => `${DEFAULT_HOST.includes('://') ? '' : 'https://'}${DEFAULT_HOST}`

// The default locale is served unprefixed ('as-needed'), so a `/en/...` target costs a redirect.
export const getLocalizedPath = (path: string, locale: Locale) => {
  const localePrefix = locale === routing.defaultLocale ? '' : `/${locale}`
  // an empty path must not add a trailing slash — '/sk/' redirects to '/sk'
  const normalizedPath = !path || path === '/' ? '' : path.startsWith('/') ? path : `/${path}`
  return `${localePrefix}${normalizedPath}` || '/'
}

// `origin` defaults to the current environment's host; pass it explicitly to build URLs for a
// fixed host (the sitemap pins PRODUCTION_ORIGIN so it can be prerendered at build time).
export const getAbsoluteUrl = (path: string, locale: Locale, origin: string = getOrigin()) =>
  `${origin}${getLocalizedPath(path, locale)}`
